// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// import { store } from './store/'
import Web3 from 'web3'

Vue.config.productionTip = false

// if (typeof window.web3 !== 'undefined') {
// 	try {
// 		window.web3 = new Web3(window.web3.currentProvider)
// 		console.log('Web3 injected browser: OK - MetaMask is enabled')
// 	} catch (err) {
//         console.log(err)
//     }
// } else {
// 	try {
// 		window.web3 = new Web3(new Web3.providers.HttpProvider('http://localhost:7545'))
// 		console.log('Web3 injected browser: OK - MetaMask is missing, defaulting to Http. You should consider trying MetaMask.')
// 	} catch (err) {
//         console.log(err)
//     }
// }

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  // store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js